import { Children, cloneElement, useEffect } from 'react';

import { useDepartmentPostQuery } from '../../../Common/Queries/departmentQueries';
import { useAddLocationQuery } from '../../../Common/Queries/locationQueries';

/**
 * @function formateData
 * @param value
 * @returns formated values
 */
export const formateData = (value) => {
  return { name: value.name };
};
const initialValues = { name: '' };

export function AddLocationContainer({ title, children, setOpen, handlePutCalendarID }) {
  const child = Children.only(children);
  const postToLocation = useAddLocationQuery();
  const postToDepartment = useDepartmentPostQuery();

  /**
   * this function is utility function for submit data get by user
   * @param e default parameter
   * @param values location parameter
   */
  function handleSubmitForAddLocation(values) {
    const reqBody = formateData(values);
    if (title === 'Location') postToLocation.mutate(reqBody);
    else postToDepartment.mutate(reqBody);
  }

  useEffect(() => {
    if (postToLocation.isSuccess || postToDepartment.isSuccess) setOpen(false);
  }, [postToLocation.isSuccess, postToDepartment.isSuccess]);

  return cloneElement(child, {
    title,
    postToLocation,
    postToDepartment,
    handleSubmitForAddLocation,
    initialValues,
    handlePutCalendarID,
  });
}
